<div class="main-container">
  <div class="input-container">
    <input type="checkbox" [checked]="inChecked" (change)="onCheckboxChange($event)" />
    <label>{{ label }}</label>
  </div>

  <!-- <div class="counter-container" *ngIf="withCount">
    <span class="operator" (click)="isCheckedState && decrement()">-</span>
    <span class="counter">{{ countState }}</span>
    <span class="operator" (click)="isCheckedState && increment()">+</span>
  </div> -->
</div>